import maIsohService from "../maIsohService/maIsohService";
import 'angular-toarrayfilter';

export default angular.module('carDimensions', [
	maIsohService,
	'angular-toArrayFilter'
])
	.service('carDimensions', function(maIsoh) {
		this.dimensions = [];
		this.lastSync = '1.1.1970';

		/**
		 * Set default storage and set values
		 */

		let db = JSON.parse(localStorage.getItem('carDimensions'));   //*@include ../../../carDimensions.json

		if(db != null) {
			this.dimensions = typeof db.dimensions == "undefined" ? this.dimensions : db.dimensions;
			this.lastSync = typeof db.lastSync == "undefined" ? this.lastSync : db.lastSync;
		} else {
			db = {};
		}

		this.setDimensions = (dimensions) => {
			this.dimensions = angular.copy(dimensions);

			this.dimensions.forEach((item) => {
				item.cetnost = parseInt(item.cetnost);
			});

			db.dimensions = this.dimensions;
			localStorage.setItem('carDimensions', JSON.stringify(db));
		};

		this.setLastSync = (date) => {
			this.lastSync = date;
			db.lastSync = this.lastSync;
			localStorage.setItem('carDimensions', JSON.stringify(db));
		};

		this.getDimensions = () => {
			return angular.copy(this.dimensions);
		};


		this.getLastSync = () => {
			return angular.copy(this.lastSync);
		};

		this.markLastSync = () => {
			let now = new Date();
			this.setLastSync(now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear());
		};

		this.checkDimensions = () => {
			if(this.dimensions.length < 1) {
				this.loadCarDimensions();
			}
		}

		/**
		 * Load car dimensions from server
		 */
		this.loadCarDimensions = () => {
			maIsoh.loadCarDimensions(this.getLastSync()).then((result) => {
				if (angular.isDefined(result.json.znacky.item)) {
					this.setDimensions(result.json.znacky.item);
					this.markLastSync();
				} else {
				}
			}).catch((error) => {
				console.error(error.message);
			})
		};
	}).directive('carSelector', function() {
		return {
			template: `
				<button class="btn btn-{{ctrl.btnClass}}" uib-tooltip="{{ctrl.tooltip}}" ng-click="ctrl.openSelector()"><i class="fa fa-comment"></i></button>`,
			restrict: 'E',
			scope: {},
			replace: true,
			bindToController: {
				selectTo: '=',
				btnClass: '<',
				tooltip: '<',
				onSelect: '<'
			},
			controller: function(ngDialog, $scope, $timeout) {
				if(angular.isUndefined(this.tooltip)) {
					this.tooltip = 'Vybrat z číselníku';
				}

				if(angular.isUndefined(this.btnClass)) {
					this.btnClass = 'warning';
				}

				/**
				 * Open modal for changing password
				 */
				this.openSelector = () => {
					ngDialog.open({
						template: 'services/carDimensions/selector.tpl.html',
						controller: function($scope, carDimensions) {
							this.carDimensions = carDimensions.getDimensions();

							this.carDimensions.forEach((item) => {
								item.cetnost = parseInt(item.cetnost);
							});

							this.selectMostCommon = (item) => {
								$scope.closeThisDialog({value: item});
							};

							this.select = () => {
								if(angular.isDefined(this.selected)) {
									$scope.closeThisDialog({value: this.selected.originalObject});
								} else {
									$scope.closeThisDialog(false);
								}
							};
						},
						controllerAs: 'ctrl',
						name: 'carSelectorDialog'
					}).closePromise.then((response) => {
						if(angular.isDefined(response.value.value)) {
							this.selectTo = response.value.value.kod;
							if(angular.isFunction(this.onSelect)) {
								this.onSelect(response.value.value);
							}
						}
					});
				};

				/**
				 * Ugly, dirty OMFG solution, but this autocomplete does not support programmatic focus
				 */
				$scope.$on('ngDialog.opened', function(e, dialog) {
					if(dialog.name == 'carSelectorDialog') {
						$timeout(() => {
							document.querySelector('#_value').focus();
						});
					}
				});
			},
			controllerAs: 'ctrl'
		};
	}).name;



// WEBPACK FOOTER //
// build/services/carDimensions/carDimensions.js